import { useGetPresencesQuery, useUpdatePresenceMutation } from "./presencesApiSlice"
import Presence from './Presence'
import useTitle from "../../hooks/useTitle"
import PulseLoader from 'react-spinners/PulseLoader'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowsV } from "@fortawesome/free-solid-svg-icons"
import { Link, useNavigate, useParams } from "react-router-dom"
const PresencesList = ({txt}) => {
    const {groupId} = useParams()
    useTitle('geshtop-Exercise: Presences List')
    const navigate = useNavigate()
    const {
        data: presences,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetPresencesQuery('presencesList', {
        // pollingInterval: 60000,
        // refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    })


    let content

    if (isLoading) content = <PulseLoader color={"#FFF"} />

    if (isError) {
        content = <p className="errmsg">{error?.data?.message}</p>
    }

    if (isSuccess) {
        const filtered =  presences.filter(presence=>{
                return ( (txt==='' ||presence.lessonTitle.toLowerCase().indexOf(txt) > -1 )
                && (groupId ==='0' ||  presence.group?._id=== groupId))
                   
            })
       
        const tableContent = filtered.length && filtered.map(presence => <Presence key={presence._id} presence={presence} />)
        content = (
            <>
     
   

     <table className="table table--presences table--presences-student">
                <thead className="table__thead">
                    <tr>
                        <th scope="col" className="table__th presence__presencename">שיעור</th>
                        <th scope="col" className="table__th presence__lessons">מס' שיעורים</th>
                        <th scope="col" className="table__th presence__name">תאריך</th>
                        <th scope="col" className="table__th presence__name">תעודת זהות</th>
                        <th scope="col" className="table__th presence__name">שם</th>
                        <th scope="col" className="table__th presence__name">נוכחות</th>
                        <th scope="col" className="table__th presence__edit">#</th>
                    </tr>
                </thead>
                <tbody>
                    {tableContent}
                </tbody>
            </table>
            </>
        )
    }

    return content
}
export default PresencesList